'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LOG_FILTER_ACTIONS = undefined;
exports.default = configureEditorStore;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _redux = require('redux');

var _reduxLogger = require('redux-logger');

var _getClientConfig = require('../../../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _index = require('./reducers/index');

var _index2 = _interopRequireDefault(_index);

var _configConstants = require('../../../../../config/configConstants');

var _editorConstants = require('./editorConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Utils


// Reducer


// Constants


// Actions to filter from the logger
var LOG_FILTER_ACTIONS = exports.LOG_FILTER_ACTIONS = Immutable.Map(_defineProperty({}, _editorConstants.EDITOR_STATE_CHANGED, _configConstants.DEBUG_LEVEL.FINE));

function configureEditorStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();

    var middlewareList = [];
    var config = (0, _getClientConfig2.default)();

    if (config.debugLevel > _configConstants.DEBUG_LEVEL.OFF) {
        var filteredActions = LOG_FILTER_ACTIONS.filter(function (logLevel) {
            return logLevel >= config.debugLevel;
        }).keySeq().toArray();

        middlewareList.push((0, _reduxLogger.createLogger)({
            predicate: function predicate(getState, action) {
                return filteredActions.indexOf(action.type) === -1;
            },
            collapsed: true,
            duration: true,
            colors: {
                title: function title(action) {
                    return 'goldenrod';
                }
            }
        }));
    }

    var middleware = _redux.applyMiddleware.apply(null, middlewareList);

    return (0, _redux.createStore)(_index2.default, initialState, middleware);
}


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/configureEditorStore.js
// module id = 1749
// module chunks = 0